module.exports = __webpack_public_path__ + "static/media/MS-Sans-Serif.f27c0623.ttf";